import React from "react";
import { FaBars, FaSignOutAlt } from "react-icons/fa";

const Header = ({ title, sidebarOpen, setSidebarOpen }) => {
  const accountType = localStorage.getItem("account_type");
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div className="header-dashboard">
      <div className="wrap">
        {/* Left Section */}
        <div className="header-left">
          {/* ✅ Toggle Sidebar */}
          <div
            className="button-show-hide cursor-pointer"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <FaBars />
          </div>
          <h6>{title}</h6>
        </div>

        {/* Right Section */}
        <div className="header-grid">
          <div className="popup-wrap user type-header">
            <div className="dropdown">
              <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                id="dropdownMenuButton3"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="header-user wg-user">
                  <span className="image">
                    <img src="/images/avatar/user-1.png" alt="" />
                  </span>
                  <span className="content flex flex-column">
                    <span className="label-02 text-Black name">
                      {user?.F_name}
                    </span>
                    <span className="f14-regular text-Gray">{accountType}</span>
                  </span>
                </span>
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end has-content"
                aria-labelledby="dropdownMenuButton3"
              >
                <li>
                  <a href="/logout" className="user-item">
                    <FaSignOutAlt className="me-2" /> Log out
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
